module.exports = __webpack_public_path__ + "static/media/trash-alt.974679dc.svg";